var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.818 12.938a2.6 2.6 0 0 1-1.932-.82q-.795-.822-.795-1.993t.795-1.992a2.6 2.6 0 0 1 1.932-.82 2.6 2.6 0 0 1 1.932.82q.796.82.796 1.992t-.796 1.992a2.6 2.6 0 0 1-1.932.82M7.455 15.75q-.75 0-1.285-.55a1.83 1.83 0 0 1-.534-1.325v-7.5q0-.774.534-1.324.535-.55 1.285-.551h12.727q.75 0 1.284.55.534.552.534 1.325v7.5q0 .774-.534 1.324t-1.284.551zm1.818-1.875h9.09q0-.774.535-1.324.534-.55 1.284-.551V8.25q-.75 0-1.284-.55a1.83 1.83 0 0 1-.534-1.325H9.273q0 .774-.534 1.324t-1.284.551V12q.75 0 1.284.55.534.552.534 1.325m9.09 5.625H3.819q-.75 0-1.284-.55A1.83 1.83 0 0 1 2 17.624V8.25q0-.399.261-.668.262-.27.648-.27.387 0 .648.27t.261.668v9.375h14.546q.386 0 .647.27.262.27.262.668a.92.92 0 0 1-.262.668.87.87 0 0 1-.647.269"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.d59cabdfdcbc528c6f5c7556f0ab174b.svg";
export { ForwardRef as ReactComponent };